<div class="submission-rules-container">
  <div class="title-bar-container">
    <div class="title-bar">
      <app-edit-template-name
        [templateName]="templateName"
        [isTemplateNameBeingEdited]="false"
        [showEditIcon]="false"
      ></app-edit-template-name>
      <button class="btn btn-link" (click)="goBack()">
        <i class="fas fa-chevron-left"></i> Back to Template Editor
      </button>
    </div>
  </div>

  <div class="submission-rules-body-container">
    <div class="submission-rules-header">
      <div class="submission-rules-header-label">
        <h4>
          Submission Rules
          <span class="rules-count"><i class="fas fa-list-check"></i>{{ rulesCount }} Rules Created</span>
          @if (errorCount > 0) {
            <span class="error-indicator">
              <i class="fas fa-exclamation-circle"></i>{{ errorCount }} error
            </span>
          }
        </h4>
      </div>
      <div class="submission-rules-action-buttons">
        <button class="btn btn-light btn-link" (click)="importRules()">
          <i class="fas fa-file-import"></i> Import
        </button>
        <button class="btn btn-light btn-link" (click)="exportRules()">
          <i class="fas fa-file-export"></i> Export
        </button>
        <button class="btn btn-light-primary" (click)="addSubmissionRule()">
          <i class="fas fa-plus"></i> Add Submission Rule
        </button>
        <button class="btn btn-primary" (click)="saveRules()" [disabled]="!canSaveState">
          Save Rules
        </button>
        @if (canCancelState) {
          <button class="btn btn-outline-secondary" (click)="cancelChanges()">
            Cancel
          </button>
        }
      </div>
    </div>

    <div class="submission-rules-content">
      @if (rulesCount === 0) {
        <div>
          <app-table-empty-state
            [emptyStateIcon]="'fa-exclamation-circle'"
            [headerText]="'No Submission Rules Created'"
            [helpText]="'Click below to add a new submission rule or use the \'Import\' feature above to upload a csv file.'"
          ></app-table-empty-state>
          <div class="button-container">
            <button class="btn btn-primary btn-sm add-submission-rule-btn" (click)="addSubmissionRule()">
              <i class="fas fa-plus"></i> Add Submission Rule
            </button>
          </div>
        </div>
      }
      @if (rulesCount > 0) {
        <div class="submission-rules-table-container">
          <table class="submission-rules-table">
            <tbody>
              @for (rule of submissionRules; track trackByRuleId($index, rule)) {
                <tr class="submission-rule-row">
                  <td class="rule-cell cell-if">if</td>
                  <td class="rule-cell cell-template-item">Template Item</td>
                  <td class="rule-cell cell-line-item-dropdown">
                    <div [class.danger-border]="!rule.templateItem || rule.templateItem.trim() === ''">
                      <app-select2
                        [data]="availableTemplateItems"
                        [value]="rule.templateItem"
                        (valueChanged)="onTemplateItemChange(rule, $event.value)"
                        placeholder="Template Item is required"
                        [width]="'100%'"
                        [class.error-dropdown]="rule.hasError"
                        [allowCustomDisplayText]="true"
                      ></app-select2>
                    </div>
                    @if (rule.hasError) {
                      <div class="error-message">
                        <i class="fas fa-exclamation-circle"></i>{{ rule.errorMessage }}
                      </div>
                    }
                  </td>
                  <td class="rule-cell cell-arrow"><span class="arrow">→</span></td>
                  <td class="rule-cell cell-is">Is</td>
                  <td class="rule-cell cell-condition-dropdown">
                    <div [class.danger-border]="!rule.condition || rule.condition.trim() === ''">
                      <app-select2
                        [data]="availableConditions"
                        [value]="rule.condition"
                        (valueChanged)="onConditionChange(rule, $event.value)"
                        placeholder="Condition is required"
                        [width]="'100%'"
                        [options]="{minimumResultsForSearch: -1}"
                      ></app-select2>
                    </div>
                  </td>
                  <td class="rule-cell cell-arrow"><span class="arrow">→</span></td>
                  <td class="rule-cell cell-equation-label">The Equation</td>
                  <td class="rule-cell cell-equation-text">
                    <input
                      type="text"
                      class="form-control"
                      [class.danger-border]="!rule.equation || rule.equation.trim() === ''"
                      [value]="rule.equation"
                      (input)="onEquationChange(rule, $event.target.value)"
                      placeholder="Ex: =1.25"
                      />
                  </td>
                  <td class="rule-cell cell-then">then</td>
                  <td class="rule-cell cell-arrow"><span class="arrow">→</span></td>
                  <td class="rule-cell cell-mark-line-item-as">Mark Line Item As</td>
                  <td class="rule-cell cell-action">
                    <div [class.danger-border]="!rule.action || rule.action.trim() === ''">
                      <app-select2
                        [data]="availableActions"
                        [value]="rule.action"
                        (valueChanged)="onActionChange(rule, $event.value)"
                        placeholder="Select action"
                        [width]="'100%'"
                        [options]="{minimumResultsForSearch: -1}"
                        [showDescriptions]="true"
                      ></app-select2>
                    </div>
                  </td>
                  <td class="rule-cell cell-delete">
                    <button class="btn btn-light-danger" (click)="deleteSubmissionRule(rule.id)">
                      <i class="fas fa-trash text-danger"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
</div>

@if (isLoading) {
  <div class="loading-overlay">
    <div class="loader__container">
      <div class="loader"></div>
    </div>
  </div>
}